// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BUKu","colMin":"styles_colMin__2Dt5Z"};